/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum PanelCircuitDataReturnCodes {
  NoSelection = 0,
  SelectionMismatch = 1,
  Success = 2,
  ValidSelection = 3,
  Error = 4,
  InvalidSelection = 5,
  None = 6,
  CableTrayMismatch = 7,
  ConduitMismatch = 8,
  InvalidWireFillSelection=9,
  WireFillApplied=10,
}
